export default __webpack_public_path__ + "static/media/misc.716c12b0.png";